// TODO: Refactor this entire component TS layer
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// Imports
import Vue from "vue";
import Component from "vue-class-component";
import { Rounds } from "../../../modules/rounds";
// Define vue parameters
var RoundScorecardComponent = /** @class */ (function (_super) {
    __extends(RoundScorecardComponent, _super);
    /**
     * Setup the child and parent class
     */
    function RoundScorecardComponent() {
        var _this = _super.call(this) || this;
        // Create a rounds instance
        _this.rounds = new Rounds();
        return _this;
    }
    /**
     * Component setup on mount
     */
    RoundScorecardComponent.prototype.mounted = function () {
        var _this = this;
        // Populate drive types
        this.rounds.driveTypes().then(function (r) {
            _this.$data.properties.driveResultType.selectOptions = r;
        });
        // Set scorecards for use within table population
        this.$data.scorecards = this.$props.round.scorecards;
        // Set holes to list tables
        if (this.$data.scorecards[0].holes.length > 9) {
            this.$data.scorecardHoles = [
                [0, 1, 2, 3, 4, 5, 6, 7, 8],
                [9, 10, 11, 12, 13, 14, 15, 16, 17]
            ];
        }
        else {
            this.$data.scorecardHoles = [[0, 1, 2, 3, 4, 5, 6, 7, 8]];
        }
    };
    RoundScorecardComponent.prototype.formatPlayerScorecards = function () {
        var _this = this;
        // Map only secondary scorecards
        var scorecardIndexes = Object.keys(this.$refs)
            .map(function (key) {
            if (key.includes("scorecard_"))
                return key;
        })
            .filter(function (e) {
            return e != null;
        })
            .map(function (scorecard) {
            // @ts-ignore
            return parseInt(scorecard.split("_")[1]);
        });
        // Use Set to remove duplicates
        Array.from(new Set(scorecardIndexes)).forEach(function (i) {
            var scorecard = _this.$data.scorecards[i], holes = scorecard.holes;
            // i == index of scorecard
            // hole == hole number / input value
            // @ts-ignore
            var formattedHoles = holes.map(function (hole) {
                // Format hole data with returned and updated
                return {
                    scorecardId: hole.scorecardId,
                    holeNum: hole.holeNum,
                    // @ts-ignore
                    score: _this.$refs["scorecard_" + i + "_" + hole.holeNum][0]
                        .value,
                    putts: hole.putts,
                    driveResultType: hole.driveResultType,
                    penaltyStrokes: hole.penaltyStrokes,
                    bunkerHit: hole.bunkerHit
                };
            });
            // Update the player scorecard
            _this.rounds
                .updateScorecard(scorecard.scorecardId, scorecard.roundId, scorecard.playerId, formattedHoles)
                .then(function (r) {
                console.log("UPDATED PLAYER");
                console.log(r);
            });
        });
    };
    RoundScorecardComponent.prototype.formatHoles = function () {
        this.formatPlayerScorecards();
        // Get inputs
        var inputs = this.$refs, keys = Object.keys(inputs);
        console.log(inputs);
        console.log(keys);
        var globalRoundId = 0, globalPlayerId = 0, holes = {
            1: {},
            2: {},
            3: {},
            4: {},
            5: {},
            6: {},
            7: {},
            8: {},
            9: {},
            10: {},
            11: {},
            12: {},
            13: {},
            14: {},
            15: {},
            16: {},
            17: {},
            18: {}
        };
        keys.forEach(function (key) {
            // If key is different
            // Must match reference of players scorecard
            // TODO: Fix this
            if (key.includes("scorecard_")) {
                return;
            }
            // Split key to get values
            var rawValues = key.split("_"), element = inputs[key], scorecardId = parseInt(rawValues[0]), playerId = parseInt(rawValues[1]), roundId = parseInt(rawValues[2]), property = rawValues[3], hole = parseInt(rawValues[4]), value = element[0].value;
            // @ts-ignore
            holes[hole]["scorecardId"] = scorecardId;
            // @ts-ignore
            holes[hole]["holeNum"] = hole;
            // If checkbox, use checked instead of value because checkboxes don't have a value... they have a "checked" value...
            if (property == "bunkerHit") {
                // @ts-ignore
                holes[hole]["bunkerHit"] = inputs[key][0].checked;
            }
            else {
                // @ts-ignore
                holes[hole][property] = value;
            }
            // Append round / player id
            globalRoundId = roundId;
            globalPlayerId = playerId;
        });
        // Return holes as object without ids
        var holeKeys = Object.keys(holes);
        // @ts-ignore
        var rawHoles = [];
        holeKeys.forEach(function (key) {
            // @ts-ignore
            rawHoles.push(holes[key]);
        });
        // @ts-ignore
        rawHoles["roundId"] = globalRoundId;
        // @ts-ignore
        rawHoles["playerId"] = globalPlayerId;
        // @ts-ignore
        return rawHoles;
    };
    RoundScorecardComponent.prototype.updateScorecard = function () {
        var holes = this.formatHoles();
        this.rounds
            .updateScorecard(holes[0].scorecardId, holes.roundId, holes.playerId, holes)
            .then(function (r) {
            alert("Your scorecard has been updated.");
            console.log(r);
        });
    };
    RoundScorecardComponent = __decorate([
        Component({
            name: "RoundScorecardComponent",
            props: ["round", "tableHoles"],
            data: function () {
                return {
                    scorecards: null,
                    scorecardHoles: null,
                    properties: {
                        score: {
                            property: "score",
                            title: "Score",
                            inputType: "text",
                            "default": 0
                        },
                        putts: {
                            property: "putts",
                            title: "Putts",
                            inputType: "text",
                            "default": 0
                        },
                        driveResultType: {
                            property: "driveResultType",
                            title: "Drive",
                            inputType: "select",
                            selectOptions: [],
                            "default": "none"
                        },
                        penalty: {
                            property: "penaltyStrokes",
                            title: "Penalty",
                            inputType: "text",
                            "default": 0
                        },
                        bunkerHit: {
                            property: "bunkerHit",
                            title: "Bunker",
                            inputType: "checkbox",
                            "default": false
                        },
                        strokeIndex: {
                            property: "strokeIndex",
                            title: "S.I.",
                            inputType: "static",
                            "default": 0
                        }
                    }
                };
            }
        })
        // Define the component code
    ], RoundScorecardComponent);
    return RoundScorecardComponent;
}(Vue));
export default RoundScorecardComponent;
